export default "__VITE_ASSET__t2_f97bQ__"